import profileData from "./profile.json";

export const profile = profileData;

export function buildAssistantKnowledge(data = profileData) {
  const lines = [];

  lines.push(`Name: ${data.name}`);
  lines.push(`Tagline: ${data.tagline}`);
  lines.push(`Headline: ${data.headline}`);
  lines.push(`Roles: ${data.roles.join(", ")}`);
  lines.push("");
  lines.push("Bio:");
  data.bio.forEach((p) => lines.push(`- ${p}`));
  lines.push("");
  lines.push("Experience:");
  data.experience.forEach((job) => {
    lines.push(
      `- ${job.title} at ${job.company} (${job.location}, ${job.duration})`
    );
    job.description.forEach((bullet) => lines.push(`  • ${bullet}`));
  });
  lines.push("");
  lines.push("Education:");
  data.education.forEach((ed) => {
    lines.push(`- ${ed.degree} — ${ed.school} (${ed.duration})`);
  });
  lines.push("");
  lines.push("Projects:");
  data.projects.forEach((project) => {
    lines.push(
      `- ${project.title}: ${project.description} Tech: ${project.techStack.join(", ")}`
    );
    if (project.github) lines.push(`  GitHub: ${project.github}`);
    if (project.demo) lines.push(`  Demo: ${project.demo}`);
  });
  lines.push("");
  lines.push("Skills:");
  data.skills.forEach((group) => {
    lines.push(`- ${group.title}: ${group.skills.join(", ")}`);
  });
  lines.push("");
  lines.push("Contact:");
  lines.push(`- Email: ${data.contact.email}`);
  lines.push(`- LinkedIn: ${data.contact.linkedin}`);
  lines.push(`- GitHub: ${data.contact.github}`);
  lines.push(`- Calendly: ${data.contact.calendly}`);
  lines.push(`- Medium: ${data.contact.medium}`);
  lines.push("");
  lines.push("FAQs:");
  data.faqs.forEach((faq) => {
    lines.push(`Q: ${faq.q}`);
    lines.push(`A: ${faq.a}`);
  });

  return lines.join("\n");
}

export default profileData;
